export const SETTINGS = {
  root: "settings-root",
  entityForm: "settings-entity-form",
  entitySelect: "settings-entity-select",
  legalName: "settings-legal-name",
  tradeName: "settings-trade-name",
  trn: "settings-trn",
  vatRegistered: "settings-vat-registered",
  contactEmail: "settings-contact-email",
  contactPhone: "settings-contact-phone",
  addressLine: "settings-address-line",
  addressEmirate: "settings-address-emirate",
  licenceNumber: "settings-licence-number",
  licenceJurisdiction: "settings-licence-jurisdiction",
  invoicePrefix: "settings-invoice-prefix",
  entitySaveBtn: "settings-entity-save",
  entitySavedAlert: "settings-entity-saved-alert",
  entityErrorAlert: "settings-entity-error-alert",
  companyForm: "settings-company-form",
  companyTradeName: "settings-company-trade-name",
  companyContactEmail: "settings-company-contact-email",
  companyContactPhone: "settings-company-contact-phone",
  companyWhatsapp: "settings-company-whatsapp",
  companyHours: "settings-company-hours",
  companySaveBtn: "settings-company-save",
  companySavedAlert: "settings-company-saved-alert",
  navBack: "settings-nav-back",
};
